/*

Pixel Field Editor - developed by Satori, s.r.o. (c) 2014-2016 - zden@satori.sk
---------------------------------
Legal notice: Source code is for internal purposes only of developing
and integrating Pixel Field Editor to the larger asset of Forms+Surfaces
online services. Any modifications must be discussed with Satori, s.r.o. and no derivates to other projects are allowed without prior written permission from Satori, s.r.o.
---------------------------------
Satori, s.r.o. | Jegeho 21 | 821 08 Bratislava | +421-903-258-862 | www.satori.sk

*/


var PI = 3.1415926;

function RGB(r,g,b)
{
	this.r = r;
	this.g = g;
	this.b = b;
	this.str = 'rgb(' + r + ',' + g + ',' + b + ')';
	return this;
}

var m_w = 123456789;
var m_z = 987654321;
var mask = 0xffffffff;

function seed(i)
{
	m_z = 987654321;
	m_w = i;
}

function random()
{
	m_z = (36969 * (m_z & 65535) + (m_z >> 16)) & mask;
	m_w = (18000 * (m_w & 65535) + (m_w >> 16)) & mask;
	var result = ((m_z << 16) + m_w) & mask;
	result /= 4294967296;
	return result + 0.5;
}

function min(v1, v2)
{
	if (v1 < v2) return v1;
	return v2;
}

function max(v1, v2)
{
	if (v1 > v2) return v1;
	return v2;
}


function intersect_line_line(v_in, v)
{
	var t1, t2;

	var sd, s1_x, s1_y, s2_x, s2_y;
	
	s1_x = v_in.x2 - v_in.x1;
	s1_y = v_in.y2 - v_in.y1;
	s2_x = v.x2 - v.x1;
	s2_y = v.y2 - v.y1;
	
	sd = (-s2_x * s1_y + s1_x * s2_y);
	if (sd != 0)
	{
		t1 = (-s1_y * (v_in.x1 - v.x1) + s1_x * (v_in.y1 - v.y1)) / sd;
		t2 = ( s2_x * (v_in.y1 - v.y1) - s2_y * (v_in.x1 - v.x1)) / sd;

		if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) return 1;
	}
	return 0;
}

function intersect_line_rect(l, r)
{
	if (l.x1 >= r.x && l.x1 < r.x + r.w && l.y1 >= r.y && l.y1 < r.y + r.h &&
		l.x2 >= r.x && l.x2 < r.x + r.w && l.y2 >= r.y && l.y2 < r.y + r.h) return 1;
	var rl1 = { x1: r.x, y1: r.y, x2: r.x + r.w, y2: r.y };
	var rl2 = { x1: r.x + r.w, y1: r.y, x2: r.x + r.w, y2: r.y + r.h };
	var rl3 = { x1: r.x + r.w, y1: r.y + r.h, x2: r.x, y2: r.y + r.h };
	var rl4 = { x1: r.x, y1: r.y + r.h, x2: r.x, y2: r.y };
	
	if (intersect_line_line(l, rl1)) return 1;
	if (intersect_line_line(l, rl2)) return 1;
	if (intersect_line_line(l, rl3)) return 1;
	if (intersect_line_line(l, rl4)) return 1;
	return 0;
}

function inside_point_rect(x, y, r)
{
	if (x >= r.x && x < r.x+r.w && y >= r.y && y < r.y+r.h) return 1;
	return 0;
}